import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

const LedgerItem = props => {
  const classes = classNames(
    'cart-ledger__item',
    props.className,
    props.textStyle
  );

  return (
    <div className={classes}>
      <span className="cart-ledger__item__label">{props.label}</span>
      <span className="cart-ledger__item__value">{props.value}</span>
    </div>
  );
};

LedgerItem.propTypes = {
  className: propTypes.string,
  label: propTypes.oneOfType([propTypes.string, propTypes.element]).isRequired,
  textStyle: propTypes.string,
  value: propTypes.oneOfType([propTypes.string, propTypes.element]).isRequired,
};

LedgerItem.defaultProps = {
  textStyle: 'subheading',
};

export default LedgerItem;
